import { render, staticRenderFns } from "./kucuntiaozheng.vue?vue&type=template&id=7b83184c&scoped=true&"
import script from "./kucuntiaozheng.vue?vue&type=script&lang=js&"
export * from "./kucuntiaozheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83184c",
  null
  
)

export default component.exports